import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=1c620102&scoped=true&"
import script from "./ResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ResourceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGrid.vue?vue&type=style&index=0&id=1c620102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c620102",
  null
  
)

export default component.exports